import React, { useRef, useState, useEffect } from 'react';
import { Video } from './Video';
import arrow from './right-arrow.png';
import './videoCarousel.css';

interface CarouselProps{
    startAt?: number,
    videos: {
        id: string,
        src: string,
        title?: string,
        description?: string
    }[]
}

export const VideoCarousel = ({
    startAt = 0,
    videos
}: CarouselProps) => {
    const [ slide, setSlide ] = useState(startAt);
    const [ transform , setTransform ] = useState('0px');
    const [ width, setWidth ] = useState(window.screen.width > 640 ? 640 : window.screen.width - 40);
    const [ winWidth, setWinWidth ] = useState(document.body.clientWidth);
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const handler = (ev: any) => {
            setWidth(window.screen.width > 640 ? 640 : window.screen.width - 40);
            setWinWidth(document.body.clientWidth);
        }
        window.addEventListener('resize', handler);
        return () => window.removeEventListener('resize', handler);
    }, []);
    useEffect(() => {
        if(ref.current){
            setTransform(`translateX(${(slide) * -width - 10 + (Number(ref.current?.offsetWidth) - width) / 2}px)`);
        }
    }, [slide, videos, width]);

    const LeftArrow = () => <div className="flex flex-col justify-center w-52">
        <div className='w-full flex justify-center'>
            <i className="fa-solid fa-angle-left cursor-pointer fa-5x text-[#01487C]" onClick={() => setSlide(slide - 1 >= 0 ? (slide - 1) % videos.length : videos.length - 1)}></i>
        </div>
    </div>;

    const RightArrow = () => <div className="flex flex-col justify-center w-52">
        <div className='w-full flex justify-center'>
            <i className="fa-solid fa-angle-right cursor-pointer fa-5x text-[#01487C]" onClick={() => setSlide((slide + 1) % videos.length)}></i>
        </div>
    </div>

    const VideoCard = () => <div className="flex flex-row overflow-hidden" ref={ref}>
        {videos.map((child, i) => <div key={i} className="slide" style={{marginTop: `${i === slide  ? 0 : 30}px`, transform: transform, marginLeft: '10px', marginRight: '10px'}}>
            <Video key={child.id} src={child.src} title={child.title} description={child.description} height={i === slide  ? width*360 / 640 : width*360 / 640 - 20} playing={i === slide} width={width}/>
        </div>
        )}
    </div>

    return <div>
        { winWidth > 1100 ?
            <div className="flex flex-row">
                {videos.length > 1 ? <LeftArrow /> : null}
                <VideoCard />
                {videos.length > 1 ? <RightArrow /> : null}
            </div>
        :
            <div className="">
                <VideoCard />
                {videos.length > 1 ?
                    <div className="flex mt-7 justify-evenly">
                        <i className="fa-solid fa-angle-left cursor-pointer fa-5x text-[#01487C]" onClick={() => setSlide(slide - 1 >= 0 ? (slide - 1) % videos.length : videos.length - 1)}></i>
                        <i className="fa-solid fa-angle-right cursor-pointer fa-5x text-[#01487C]" onClick={() => setSlide((slide + 1) % videos.length)}></i>
                    </div>
                    : null}
            </div>
        }
    </div>
}